import angular from 'angular';
import uiRouter from 'angular-ui-router';
import resultsComponent from './results.component';

let resultsModule = angular.module('results', [
  uiRouter
]).config(($stateProvider) => {
	'ngInject';

	$stateProvider.state('results', {
		url: '/results/:id',
		component: 'results',
		data : { pageTitle: 'RESULTS' },
		params: {
			id: {squash: true, value: null}
		},
	});

})
.component('results', resultsComponent)
.name;

export default resultsModule;



// WEBPACK FOOTER //
// ./client/app/components/results/results.js